import { render, staticRenderFns } from "./ClientOrdersModal.vue?vue&type=template&id=6196507a&scoped=true"
import script from "./ClientOrdersModal.vue?vue&type=script&lang=js"
export * from "./ClientOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./ClientOrdersModal.vue?vue&type=style&index=0&id=6196507a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196507a",
  null
  
)

export default component.exports